import { MultilineText } from "@app/components/core/MultilineText/MultilineText"
import Button from "@app/components/move2Library/Button/Button"
import { useGetStrings } from "@app/store/service/cmsService"
import { RenderHTML } from "@app/utils/htmlUtils"
import { Modal, useModal } from "@tecreation/funnel-components"

import { Loader } from "@app/components/core/Loader/Loader"
import { useGetEmployeeNews } from "@app/store/service/connectorService"
import "./MyParadiseNewsModal.css"

export function MyParadiseNewsModal({ news }) {
	const {
		data: { buttonClose },
	} = useGetStrings(undefined, { defaultData: {} })
	const { hideModal } = useModal()

	const srcUrl = news.medias?.find(e => e.thumbnail === true)?.url

	const { isFetching, data: message } = useGetEmployeeNews({ messageId: news.messageId })

	return (
		<Modal className="myParadiseNewsModal">
			<Modal.Closer />
			<Modal.Header className="color-fg-secondary">
				<RenderHTML html={news.subject} />
			</Modal.Header>
			<Modal.Body>
				{isFetching && <Loader show />}
				{!isFetching && (
					<>
						<img src={srcUrl} style={{ opacity: 1, width: "100%", maxWidth: "30vH", height: "auto" }} />

						<div className="mt-3">
							<MultilineText>
								<RenderHTML html={message.content} />
							</MultilineText>
						</div>
					</>
				)}
			</Modal.Body>

			<Modal.Footer>
				<div className="flex w-100 flex-center">
					<Button style="primary" onClick={hideModal}>
						{buttonClose}
					</Button>
				</div>
			</Modal.Footer>
		</Modal>
	)
}
